import type { Prisma } from "@prisma/client";

export const resourceTypes = ["DOCUMENT", "FORMATION", "EVENT"] as const;
export type ResourceType = (typeof resourceTypes)[number];
export const resourceTypeLabels = {
    DOCUMENT: "Document",
    FORMATION: "Formation",
    EVENT: "Événement",
} as const;

export const resourceSelector = {
	id: true,
	name: true,
	description: true,
	type: true,
	themeId: true,
	theme: {
		select: {
			id: true,
			name: true,
			type: true,
		},
	},
	fileId: true,
	file: {
		select: {
			id: true,
			key: true,
			bucket: true,
			name: true,
			mimeType: true,
			size: true,
		},
	},
	createdAt: true,
	updatedAt: true,
} satisfies Prisma.ResourceSelect;

export const resourceThemeSelector = {
	id: true,
	name: true,
	type: true,
	createdAt: true,
	updatedAt: true,
} satisfies Prisma.ResourceThemeSelect;

export const resourceThemeWithResourcesSelector = {
	id: true,
	name: true,
	type: true,
	resources: {
		select: {
			id: true,
			name: true,
		},
	},
	createdAt: true,
	updatedAt: true,
} satisfies Prisma.ResourceThemeSelect;